<template>
  <div class="fuchuang" @click="goxzJs" v-show="chachaShow">
    <img src="~@/assets/images/insuranceImg/whatIn.png" alt="" />
    <div class="btnJS">穗优计划介绍</div>
    <span class="textFf">什么是穗优计划?</span>
  </div>
</template>

<script>
export default {
  name: "FuBox",
  data() {
    return {
      chachaShow: true,
    };
  },
  methods: {
    closeBig() {
      this.chachaShow = false;
    },
    goxzJs() {
      this.$router.push("/introduce");
    },
  },
};
</script>

<style lang="scss" scoped>
.fuchuang {
  position: fixed;
  width: 187px;
  height: 158px;
  bottom: 10%;
  right: 5%;
  z-index: 1;
  cursor: pointer;
  text-align: center;
  color: #fff;

  .chahcha {
    position: absolute;
    top: 10px;
    right: 10px;
    color: #fff;
    cursor: pointer;
    width: 20px;
    height: 20px;
    text-align: center;
  }
  .textFf {
    position: absolute;
    top: 42%;
    left: 0;
    width: 100%;
  }
  .btnJS {
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translateX(-50%);
    width: 92px;
    line-height: 28px;
    background: linear-gradient(0deg, #2ae099 0%, #3bd6a3 100%);
    border-radius: 30px;
    font-size: 10px;
  }
}
</style>
